import React, { ReactNode } from 'react';
import Footer from './Footer';
import Header from './Header';

interface LayoutProps {
    children?: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {

    return (
        <div className='page'>
            <Header title='Expert Suite' />
            <main id='main' tabIndex={-1}>
                {children}
            </main>
            <Footer />
        </div>
    );
};

export default Layout;
